<main>
    <div class="app app-margin" >
        <div class="app-container-pm">
            <section class="nav-area-sm" [dir]="textDir">             
                <div class="row top-section padT15">
                    <div class="md-12 lg-12 xl-12">
                        <section class="breadcrmb"><a [routerLink]="['/']" >{{'Home' | translate}}</a> <span> <span style="color: #b1b3b4;">&nbsp;/&nbsp;</span>  </span><a [routerLink]="['/projectmanagement']" >{{'Project management' | translate}}</a> <span> <span style="color: #b1b3b4;">&nbsp;/&nbsp;</span>  </span> <a class="active">{{'Add a new project' | translate}}</a></section>
                        <h4 class="marT10 header-title">{{'Add a new project' | translate}}</h4>
                    </div>
                </div>
                <div class="row">
                    <div class="lg-12 sm-12 md-12 count_text">
                        
                    </div>
                </div>            
            </section>
            <div class="app-container top-section marT20" [dir]="textDir">
                <div class="row">
                    <div class="loading" *ngIf="!loaded"></div>
                    <div class="lg-3 marT30 marL10" style="position:relative;height:85px;">
                        <!-- wizard -->
                        <app-ctl-wizard-steps [ctlSteps]=this.wizardSteps [activestep]=currentSteps></app-ctl-wizard-steps>
                    </div>
                    <div class="lg-6 marL10 marT10 ">
                        <form [formGroup]="projectForm" enctype="multipart/form-data">
                            <!-- project add wizard start-->
                            <div class="loading" *ngIf="!loaded"></div>
                            <div class="prehight-addproject  form-wid white" >
                                <ng-container *ngIf="currentSteps===1">
                                    <app-ctl-project-form
                                        [viewType]="'add'"
                                        [project_id]="''"
                                        [myFormGroup]="projectForm"
                                        [myCountryList]="countryList"
                                        [myPartnerList]="partnerList"
                                        [myLeadPartner]="leadPartner"
                                        [fromParent]="toChild"
                                        (openModal)="openPartnerModal()"
                                        (myFormChange)="projectFormChange($event)">
                                    </app-ctl-project-form>
                                </ng-container>
        
                                <ng-container *ngIf="currentSteps===2">
                                    <app-ctl-project-detail
                                        [myFormGroup]="projectForm"
                                        data=projectData
                                        (editLink)="backStep()">
                                    </app-ctl-project-detail>
                                </ng-container>
                            </div>
                            <!-- project add wizard end-->
                        </form>
                        <div class="white-bg marB20" >
                            <!--<div class="marT20" style="align-items: middle; width:529px;">-->
                              <hr>
                              <div *ngIf="step" class="spaceBtwn btn-pos">
                                 <div><button [routerLink]="['/projectmanagement']" class="btn btn-cancel">{{'Cancel' | translate}} </button></div> 
                                 <div> 
                                     <button (click)='backStep()' *ngIf="(currentSteps > 1)" class="btn btn-back"><i class="icon icon-arrow-left"></i>{{'Edit' | translate}} </button>
                                    <button *ngIf="(currentSteps==1 && this.btnnext == false )" class="btn btn-next primary disabled"  [disabled]="(currentSteps==1 && this.btnnext == false )"> {{'Review' | translate}} <i class="icon icon-arrow-right padL5 marR0"></i></button>
                                    <button (click)='nextStep()' *ngIf="(currentSteps==1 && this.btnnext == true )" class="btn btn-next primary"> {{'Review' | translate}}  <i class="icon icon-arrow-right padL5"></i> </button>
                                    <button (click)='onAddProjectFormSubmit()' *ngIf="currentSteps==2" class="btn btn-next primary" [disabled]="completeDisabled"> {{'Complete' | translate}} </button>
                                </div>
                              </div>
                            
                        </div>
                        <div class=" flexStart info-txt marL5 marT20" ><i class="icon icon-info padT5"></i> <label class="info-txt grey_text padT5 padL5 " [dir]="textDir"> {{'Project details can be edited' | translate}}</label></div>
                    </div>
                    
                </div>
            </div>            
        </div>
    </div>
</main>
<lib-modalform
    modalClass="partner"
    modalID="partnerModal"
    [viewType]="'add'"
    [btnSaveText]="btnTextAdd"
    [btnSaveStatus]="btnStatusAdd"
    [btnCancelText]="btnTextCancel"
    (saveEvent)="addPartner()"
    (cancelEvent)="cancelPartner()">
    <div class="modalBody">
        <app-ctl-partner-form
            type="add"
            [pageTitle]=this.partnerTitle
            [partnerListData]=this.partnerList
            (myFormChange)="partnerFormChange($event)">
        </app-ctl-partner-form>
    </div>
</lib-modalform>
<lib-ctl-success-modal
  [titleMessage]=this.titleMessage
  [subTitleMessage]=this.subTitleMessage
  [detailMessage]=this.detailMessage
  [detailMessageLine1]=this.detailMessageLine1>
</lib-ctl-success-modal>

<!-- Error modal -->
<lib-modalform
    modalClass="errorModal"
    modalID="errorModal"
    [viewType]="'add'"
    [modalTitle]="titleMessage"
    [btnCancelText]="'Ok'"
    (cancelEvent)="''">
    <div class="modalBody errorModalWidth">
        <div class="padLR20  padT20 flexStart">
            <div [ngClass]="textDir=='ltr'?'marR15':'marL15'">
                <img src="assets/images/error3x.png" width=29 height=29 alt="">
            </div>
            <div > 
            <label class="form-title" > {{this.titleMessage}}</label>           
            </div>
        </div>    
        <div class="pad65 padR20 padB20 dialog-body-txt">
            <label  *ngIf="this.subTitleMessage"  [innerHTML]="subTitleMessage"></label>
            <label  *ngIf="this.detailMessage1"  [innerHTML]="detailMessage1"></label>
            <label  *ngIf="this.detailMessage2"  [innerHTML]="detailMessage2"></label>
        </div>
    </div>
</lib-modalform>
